import { ComponentStyleConfig } from "@chakra-ui/react";

const Text: ComponentStyleConfig = {
  baseStyle: {},
  variants: {
    merchant: {
      fontWeight: "bold",
      fontSize: "14px",
      whiteSpace: "normal",
      wordBreak: "break-word",
      marginTop: { base: "16px", xl: "0" },
      transition: "none",
      _first: {
        marginTop: "0",
      },
    },
    merchantValue: {
      fontSize: "14px",
      whiteSpace: "normal",
      wordBreak: "break-word",
      cursor: "text",
      transition: "none",
    },
  },
};

export default Text;
